import { numberToPixel } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/conversions";
import { ContentWidth } from "@faire/web-api--source/indigofair/data/ContentWidth";

const contentWidthToPixels: Partial<Record<ContentWidth, number>> = {
  [ContentWidth.DESKTOP_STANDARD]: 1280,
  [ContentWidth.DESKTOP_LARGE]: 1376,
  [ContentWidth.DESKTOP_XLARGE]: 1920,
};

export const getContentWidthPixels = (
  contentWidth:
    | keyof typeof ContentWidth
    | undefined = ContentWidth.CONTENT_WIDTH_UNKNOWN
): string | undefined => {
  return numberToPixel(contentWidthToPixels[contentWidth]) ?? "none";
};
